const trimValues = ['normal', 'start', 'end', 'both'];
const trimProp = {
    type: 'enum',
    values: trimValues,
    default: undefined,
    responsive: true,
};
export { trimProp };
//# sourceMappingURL=leading-trim.prop.js.map